import styles from "../illustration.module.scss";
import { Diamond, Plus, Ring } from "./shapes";

const BACK_BARS = [26.03, 46.1, 66.18, 86.25];
const FRONT_BARS = [21.62, 43.9, 66.18, 88.46];

/**
 * `ilustração` do Hub-Desenvolvimento (4762:68515), 128×61: duas linhas de tabela empilhadas, a da frente em destaque.
 * A sombra da linha da frente fica de fora: o nó 4762:68515 não abre pelo MCP ("invalid node selection"), então o valor não foi lido (pendência de design).
 */
export function SemEquipe() {
  return (
    <>
      <rect
        className={styles.strokeSurface100Fill50}
        x="17.87"
        y="30.66"
        width="91.32"
        height="18.09"
        rx="6.84"
        strokeWidth="0.44"
      />
      {BACK_BARS.map((x) => (
        <rect
          key={x}
          className={styles.fillSurface100}
          x={x}
          y="38.16"
          width="14.78"
          height="3.09"
          rx="1.54"
        />
      ))}
      <rect
        className={styles.fillSurface0}
        x="13.24"
        y="11.47"
        width="100.59"
        height="22.06"
        rx="7.06"
      />
      {FRONT_BARS.map((x) => (
        <rect
          key={x}
          className={styles.fillPrimary700}
          x={x}
          y="20.96"
          width="16.99"
          height="3.09"
          rx="1.54"
        />
      ))}
      <Diamond cx={7.09} cy={8.85} size={3.69} />
      <Diamond cx={108.12} cy={56.5} size={3.69} />
      <Plus cx={121.54} cy={15.19} arm={1.99} width={0.89} />
      <Plus cx={16.36} cy={3.31} arm={1.99} width={0.89} />
      <Ring cx={106.1} cy={4.19} r={1.54} width={0.88} />
      <Ring cx={21.84} cy={58.01} r={1.54} width={0.88} />
    </>
  );
}
